import _ from "lodash";
import { List, Message } from "semantic-ui-react";
import PropTypes from "prop-types";

function MessageErrorsValidation({ errors }) {
  return (
    !_.isEmpty(errors) && (
      <Message negative>
        <List bulleted>
          {Object.keys(errors).map((key) => (
            <List.Item key={key}>{errors[key]}</List.Item>
          ))}
        </List>
      </Message>
    )
  );
}

MessageErrorsValidation.propTypes = {
  errors: PropTypes.object.isRequired,
};

export default MessageErrorsValidation;
